import { DetailsRow, SelectionMode, Stack } from '@fluentui/react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataDocument } from '../../data/DataDocument';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxDocumentLotCategorie } from '../ComboBox/ComboBoxDocumentLotCategorie';
import { ComboBoxDocumentLotType } from '../ComboBox/ComboBoxDocumentLotType';
import { ComboBoxDocumentOperationCategorie } from '../ComboBox/ComboBoxDocumentOperationCategorie';
import { ComboBoxDocumentOperationType } from '../ComboBox/ComboBoxDocumentOperationType';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { EUIDialog } from '../EUI/EUIDialog';
import { EUIPanel } from '../EUI/EUIPanel';
import { EUIToggle } from '../EUI/EUIToggle';
import { FicheDocument } from '../Fiche/FicheDocument';
import { FicheImportDocument } from '../Fiche/FicheImportDocument';
import { FicheTelechargementDocuments } from '../Fiche/FicheTelechargementDocuments';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class DetailsListDocument extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListDocumentWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListDocumentWithPerimetre extends Component {

    static defaultProps = {
        onSelection: (items) => null,
        origine: undefined, // DossierClient par ex.
        perimetre: {}
    };

    static defaultState = {
        items: [],
        itemsSelectionnes: [],
        selectedDocument: {},
        selectedDocuments: [],
        peutSupprimerDocument: false,
        /* --- */
        afficherDialogSuppressionDocuments: false,
        afficherPanelDocument: false,
        afficherPanelFiltres: false,
        afficherPanelImportDocument: false,
        /* --- */
        pageIndex: 1,
        facteurNbreEnregistrement: 500,
    };


    constructor(props) {
        super(props);
        this.state = { ...DetailsListDocumentWithPerimetre.defaultState };
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = false;
        this._sortedColumn = "nom";
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...filtres };
        this.setState({
            afficherPanelFiltres: false,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des documents en cours'
        });

        const { origine } = this.props;
        const { facteurNbreEnregistrement, pageIndex } = this.state;
        const { filtreType, filtreIdCategorie, filtreIdSousCategorie, filtreNational, filtreRegion, filtreAgence, filtreOperation, filtreLot } = this._filtres;
        const tri = `${this._sortedColumn} ${this._isSortedDescending ? "DESC" : "ASC"}`;

        DataDocument._chargementDesDocumentsDuPerimetreSelectionne(facteurNbreEnregistrement, origine, filtreType, filtreIdCategorie, filtreIdSousCategorie, filtreNational, filtreRegion, filtreAgence, filtreOperation, filtreLot, tri, pageIndex).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const newItems = objetData[0] || [];

                let items = [];
                if (pageIndex === 1) items = newItems;
                else {
                    items = [...this.state.items];
                    items = items.concat(newItems);
                }

                const state = {
                    items,
                    peutSupprimerDocument: objetData[1],

                };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurAvecState(this, { items: [] }, retourVerif, responseFetch);
        });

    };

    _getColumns = () => {
        return [{
            key: "nom",
            name: "Nom",
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            key: 'creerLe',
            minWidth: 100,
            maxWidth: 120,
            name: 'Créé le',
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            key: 'perimetre',
            minWidth: 100,
            maxWidth: 150,
            name: 'Niveau',
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            key: 'perimetreValeur',
            minWidth: 100,
            maxWidth: 150,
            name: 'Périmètre',
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            key: 'categorie',
            minWidth: 100,
            maxWidth: 150,
            name: 'Catégorie',
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            key: 'typeDocument',
            minWidth: 100,
            maxWidth: 150,
            name: 'Sous-catégorie',
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            key: 'actif',
            minWidth: 30,
            maxWidth: 30,
            name: 'Actif',
        }, {
            isIconOnly: true,
            key: 'download',
            onRender: (item) => !item.rowGUID ? null :
                <IconButton
                    ariaLabel="Télécharger le document"
                    iconProps={{ iconName: 'TextDocument' }}
                    onClick={() => this._telechargerDocument(item.rowGUID)}
                    title="Télécharger le document"
                />
        }, {
            isIconOnly: true,
            key: 'edition',
            onRender: (item) => !item.rowGUID ? null :
                <IconButton
                    ariaLabel="Modifier le document"
                    iconProps={{ iconName: 'Edit' }}
                    onClick={this._togglePanel("Document", true, { selectedDocument: item })}
                    title="Modifier le document"
                />
        }];
    };

    _getFiltres = () => {
        return { ...PanelFiltres.defaultState };
    };

    _getItems = () => {

        const { origine } = this.props;
        const { selectedDocuments, peutSupprimerDocument } = this.state;
        let items = [];

        if (origine !== "DossierClient")
            items.push({
                iconProps: { iconName: "Upload" },
                key: "import",
                name: "Importer des documents",
                onClick: this._togglePanel("ImportDocument", true)
            });

        if (peutSupprimerDocument)
            items.push({
                key: "delete",
                name: "Supprimer des documents",
                iconProps: { iconName: "Delete" },
                disabled: selectedDocuments.length <= 0,
                onClick: this._toggleDialog("SuppressionDocuments", true)
            });

        if (!!sessionStorage.loginCompte && sessionStorage.loginCompte.startsWith("ImmocomGestNat"))
            items.push({
                key: "download",
                name: "Console de téléchargement",
                iconProps: { iconName: "Download" },
                onClick: this._togglePanel("TelechargementDocuments", true)
            });

        return items;

    };

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        this._sortedColumn = sortedColumn;
        this._isSortedDescending = isSortedDescending;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onRenderRow = (props, defaultRender) => {
        const item = this.state.items[props.itemIndex];
        if (item.actif) return defaultRender(props);
        else {
            const styles = { root: { width: 40 } };
            const onRenderCheck = () => <Stack horizontal horizontalAlign="center" verticalFill verticalAlign="center" styles={styles}>
                <Icon iconName="Blocked" styles={{ root: { color: "red" } }} />
            </Stack>;
            return <DetailsRow {...props} onRenderCheck={onRenderCheck} />;
        }
    };

    _onScroll = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _onSelectionChanged = (items) => {
        const { onSelection } = this.props;
        this.setState({ selectedDocuments: items })
        if (typeof onSelection === "function") onSelection(items);
    };

    _supprimerDocuments = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Suppression du document'
        });

        const { selectedDocuments } = this.state;

        DataDocument._onSuppressionDocument(selectedDocuments).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const state = { afficherDialogSuppressionDocuments: false };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._chargementDonnees);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _telechargerDocument = (rowGUID) => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Téléchargement en cours..."
        });

        DataDocument._onTelechargementDocument(rowGUID).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                let objetData = responseFetch.reponseAPIobjet;
                let document = Scriba.fichier().Base64VersByteArray(objetData.fileData);
                Scriba.fichier().EnregisterSous(document, objetData.nom);
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _toggleDialog = (nomDialog, isOpen, stateUpdates, callback) => () => {
        if (typeof stateUpdates !== 'object') stateUpdates = {};
        if (typeof callback !== 'function') callback = null;
        this.setState(
            {
                [`afficherDialog${nomDialog}`]: isOpen,
                ...stateUpdates
            },
            callback
        );
    };

    _togglePanel = (nomPanel, isOpen, stateUpdates, callback) => () => {
        if (typeof stateUpdates !== 'object') stateUpdates = {};
        if (typeof callback !== 'function') callback = null;
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                ...stateUpdates
            },
            callback
        );
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this._chargementDonnees();
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this._chargementDonnees();
    };

    render = () => {

        const { origine } = this.props;
        const {
            afficherDialogSuppressionDocuments, afficherPanelDocument, afficherPanelFiltres, afficherPanelImportDocument, afficherPanelTelechargementDocuments,
            items, selectedDocument
        } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            <EUIDetailsList
                canSelectItem={item => item.actif}
                columns={this._columns}
                getKey={item => item.rowGUID}
                isSortedDescending={this._isSortedDescending}
                items={items}
                menuItems={this._getItems()}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onFilterButtonClick={this._togglePanel("Filtres", true)}
                onRenderRow={this._onRenderRow}
                onScroll={this._onScroll}
                onSelectionChanged={this._onSelectionChanged}
                selectionMode={SelectionMode.multiple}
                sortedColumn={this._sortedColumn}
                wrapInScrollablePane={origine !== "DossierClient"}
            />

            <FicheDocument
                rowGUID={selectedDocument.rowGUID}
                idLot={selectedDocument.idLot}
                idOperation={selectedDocument.idOperation}
                idAgence={selectedDocument.idAgence}
                idRegion={selectedDocument.idRegion}
                type={(selectedDocument.idLot === null ? 'Operation' : 'Lot')}
                onAffichePanelDocument={afficherPanelDocument}
                onEnregistrementFiche={this._togglePanel("Document", false, { selectedDocument: {}, pageIndex: 1 }, this._chargementDonnees)}
                onAnnuleFiche={this._togglePanel("Document", false, { selectedDocument: {} })}
            />

            <FicheImportDocument
                onAffichePanelImportDocument={afficherPanelImportDocument}
                onFermeFicheImportDocument={this._togglePanel("ImportDocument", false, null, this._chargementDonnees)}
            />

            <FicheTelechargementDocuments
                isOpen={afficherPanelTelechargementDocuments}
                onDismiss={this._togglePanel("TelechargementDocuments", false)}
            />

            <PanelFiltres
                filtres={this._filtres}
                isOpen={afficherPanelFiltres}
                onDismiss={this._togglePanel("Filtres", false)}
                onValidate={this._appliquerFiltres}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="confirm" onClick={this._supprimerDocuments} text="Confirmer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("SuppressionDocuments", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppressionDocuments}
                message="Etes-vous certain de vouloir supprimer les documents sélectionnés ?"
                onDismiss={this._toggleDialog("SuppressionDocuments", false)}
                titre="Suppression des documents"
            />

        </Fragment>;
    }

};

class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
        isOpen: false,
        origine: undefined,
        /* --- */
        onDismiss: () => null,
        onValidate: () => null,
    };

    static defaultState = {
        filtreAgence: true,
        filtreIdCategorie: 0,
        filtreIdSousCategorie: 0,
        filtreLot: true,
        filtreNational: true,
        filtreOperation: true,
        filtreRegion: true,
        filtreType: "Operation",
    };

    constructor(props) {
        super(props);
        let state = this._getFiltresParDefaut();
        if (props.origine === "DossierClient") state.filtreLot = false;
        this.state = state;
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _getFiltresParDefaut = () => {
        const filtres = { ...PanelFiltres.defaultState };
        return filtres;
    };

    _reinitialiserFiltres = () => {
        this.setState(this._getFiltresParDefaut());
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    componentDidMount = () => {
        this._appliquerFiltres();
    };

    render = () => {

        const { origine } = this.props;
        const { isOpen, onDismiss } = this.props;
        const { filtreAgence, filtreIdCategorie, filtreIdSousCategorie, filtreLot, filtreNational, filtreOperation, filtreRegion, filtreType } = this.state;

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >

            <ChoiceGroup
                defaultSelectedKey={this.state.filtreType}
                options={[
                    { key: 'Operation', text: 'Opération' },
                    { key: 'Lot', text: 'Lot' }
                ]}
                onChange={(ev, option) => this.setState({ filtreType: option.key })}
            />

            {filtreType === 'Operation' &&
                <>
                    <ComboBoxDocumentOperationCategorie
                        onChange={(event, option) => this.setState({ filtreIdCategorie: option.key })}
                        selectedKey={filtreIdCategorie}
                    />
                    <ComboBoxDocumentOperationType
                        idDocumentOperationCategorie={filtreIdCategorie}
                        onChange={(event, option, index, value, item) => this.setState({ filtreIdSousCategorie: option.key })}
                        selectedKey={filtreIdSousCategorie}
                    />
                </>
            }

            {filtreType === 'Lot' &&
                <>
                    <ComboBoxDocumentLotCategorie
                        onChange={(event, option) => this.setState({ filtreIdCategorie: option.key })}
                        selectedKey={filtreIdCategorie}
                    />
                    <ComboBoxDocumentLotType
                        idDocumentLotCategorie={filtreIdCategorie}
                        onChange={(event, option) => this.setState({ filtreIdSousCategorie: option.key })}
                        selectedKey={filtreIdSousCategorie}
                    />
                </>
            }

            <EUIToggle
                checked={filtreNational}
                label="National"
                onChange={(event, checked) => this.setState({ filtreNational: checked })}
            />

            <EUIToggle
                checked={filtreRegion}
                label="Région"
                onChange={(event, checked) => this.setState({ filtreRegion: checked })}
            />

            <EUIToggle
                checked={filtreAgence}
                label="Agence"
                onText="Oui"
                offText="Non"
                onChange={(event, checked) => this.setState({ filtreAgence: checked })}
            />

            <EUIToggle
                checked={filtreOperation}
                label="Opération"
                onChange={(event, checked) => this.setState({ filtreOperation: checked })}
            />

            <EUIToggle
                checked={filtreLot}
                disabled={origine === "DossierClient"}
                label="Lot"
                onChange={(event, checked) => this.setState({ filtreLot: checked })}
            />

        </EUIPanel>;

    };

};